import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { PlaceAddress, PlaceSuggestion } from '@mr-website/schemas';

async function fetchPlaceSuggestions(input: string): Promise<PlaceSuggestion[]> {
  const response = await api.get<PlaceSuggestion[]>('/places/autocomplete', {
    params: { input },
  });
  return response.data;
}

async function fetchPlaceDetails(placeId: string): Promise<PlaceAddress[]> {
  const response = await api.get<PlaceAddress[]>(`/places/details/${placeId}`);
  return response.data;
}

export function usePlaceSuggestions(input: string, { enabled = true } = {}) {
  return useQuery({
    queryKey: ['places-autocomplete', input],
    queryFn: () => fetchPlaceSuggestions(input),
    enabled: input.length >= 3 && enabled,
    staleTime: 60_000,
  });
}

export function usePlaceDetails(placeId: string | null) {
  return useQuery({
    queryKey: ['places-details', placeId],
    queryFn: () => fetchPlaceDetails(placeId!),
    enabled: !!placeId,
    staleTime: Infinity,
  });
}
